module.exports = __webpack_public_path__ + "img/book5-active.9bc69b0d.png";